import { render, staticRenderFns } from "./devLog.vue?vue&type=template&id=546dc4d2&scoped=true"
import script from "./devLog.vue?vue&type=script&lang=js"
export * from "./devLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546dc4d2",
  null
  
)

export default component.exports